import { Component, Layout, PermDefinitionConstants, PermissionsDefinition } from "@mcleod/components";
import { RowPermsAllowDeny } from "../models/ModelPermsAllowDeny";
import { RowPermsSecureItem } from "../models/ModelPermsSecureItem";
import { PermissionsDesignerTab } from "./PermissionsDesignerTab";
import { PermissionsKeyGenerator, PermsSecureItemKeyData } from "./PermissionsKeyGenerator";
import { PermissionsSource } from "./PermissionsSource";
import { UserOrGroup } from "./UserOrGroup";

export interface SecureItemDef {
    pageIdentifier: string;
    itemName: string;
    permsDef: PermissionsDefinition;
    permsChanged: (deleted: boolean) => void;
    allowDenyChanged?: () => void;
    isAction?: boolean;
}

export class SecureItem implements SecureItemDef {
    pageIdentifier: string;
    itemName: string;
    permsDef: PermissionsDefinition;
    permissionsSource: PermissionsSource;
    permsChanged: (deleted: boolean) => void;
    allowDenyChanged: () => void;
    isAction: boolean;

    constructor(props: SecureItemDef) {
        Object.assign(this, props);
    }

    createRowPermsSecureItem(): RowPermsSecureItem {
       return RowPermsSecureItem.create(true, this.getKeyData());
    }

    createRowPermsAllowDeny(userOrGroupId: string, userOrGroup: UserOrGroup, allow: boolean = true): RowPermsAllowDeny {
        return RowPermsAllowDeny.create(true, {
            ...this.getKeyData(),
            user_or_group_id: userOrGroupId,
            user_or_group_flag: userOrGroup,
            grant_deny_flag: allow ? "G" : "D"
        })
    }

    createKeyString(): string {
        return PermissionsKeyGenerator.createKey(this.getKeyData());
    }

    getKeyData(): PermsSecureItemKeyData {
        return {
            item_name: this.itemName,
            screen_class: this.pageIdentifier,
            security_type: this.permsDef.permsType
        };
    }

    static createFromComponent(comp: Component, designerTab: PermissionsDesignerTab): SecureItem[] {
        const path = designerTab?.path;
        if (comp == null || path == null) {
            return null;
        }

        const permsChanged = (deleted: boolean) => {
            designerTab.permsChanged(comp, deleted);
        };

        if (comp instanceof Layout && comp === designerTab.designerPanel) {
            return [
                new SecureItem({
                    pageIdentifier: path,
                    itemName: RowPermsSecureItem.ENTIRE_SCREEN,
                    permsDef: PermDefinitionConstants.ENTIRE_SCREEN,
                    permsChanged
                })
            ]
        }

        if (comp?.id) {
            return comp.permissionsTypes.map((permsDef: PermissionsDefinition) => (
                new SecureItem({
                    pageIdentifier: path,
                    itemName: comp.id,
                    permsDef,
                    permsChanged
                })
            ));
        }

        return null;
    }
}
